import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppStyles, AppTheme } from '../../../styles/AppTheme'
import { AppHelper } from '../../../helpers/AppHelper'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { CommonTheme } from '../../../styles/Styles';
import { Helper } from '../../helpers/Helper';
import { AppButton } from '../AppButton';
import { ApiHelper } from '../../helpers/ApiHelper';
import { Button, Dialog, Icon, TableContainer, Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

class TableCard extends Component {
  constructor(props) {
    super(props);
    this.defaultErrMsg = 'An error occured.'
    this.skipScrollHandlerOnce = this.props.skipScrollHandler || false
    this.state = {
      inProcess: this.props.inProcess || false,
      modalOpen: false,
      maxRows: (this.props.item && this.props.item.maxRows) ? this.props.item.maxRows : 10,
      showLeftScroll: false,
      showRightScroll: false,
      localShowMoreInProcess: false
    };
  }

  componentDidMount() {
    requestAnimationFrame(() => {
      this.handleScroll()
    })
  }

  componentDidUpdate(prevProps,prevState) {
    if (this.props.isTabTable && (this.props.selectedTab || this.props.selectedTab === 0)  && (prevProps.selectedTab !== this.props.selectedTab)) {
      const countOfRows = (this.props.item && this.props.item.maxRows) ? this.props.item.maxRows : 10
      this.setState({
        maxRows: countOfRows,
      })
    }

    if(prevProps.inProcess !== this.props.inProcess) {
      this.setState({
        inProcess: this.props.inProcess || false,
      })
    }

    if (this.props.scrollHandler && !this.skipScrollHandlerOnce && !this.props.skipScrollHandler) {
      this.props.scrollHandler()
    }
    this.skipScrollHandlerOnce = false
  }

  openModalForViewAll() {
    this.setState({
      modalOpen: true
    });
  }

  handleScroll = () => {
    const el = this.tableRef
    if (!el) return

    const showLeft = el.scrollLeft > 0
    const showRight = el.scrollLeft + el.clientWidth < el.scrollWidth

    this.setState({
      showLeftScroll: showLeft,
      showRightScroll: showRight
    })
  }

  scrollLeft = () => {
    this.tableRef.scrollBy({ left: -200, behavior: 'smooth' })
  }

  scrollRight = () => {
    this.tableRef.scrollBy({ left: 200, behavior: 'smooth' })
  }

  showMoreDataInTable() {
    const countOfNewRows = this.props.showMoreRows || ((this.props.item && this.props.item.maxRows) ? this.props.item.maxRows : 10)
    this.skipScrollHandlerOnce = true
    this.setState({ localShowMoreInProcess: true }, () => {
      setTimeout(() => {
        this.setState((prevState) => ({
          maxRows: prevState.maxRows + countOfNewRows
        }), () => {
          this.setState({ localShowMoreInProcess: false })
        })
      }, 0)
    })
  }

  async onShowMoreClick({ hasHiddenLocalRows, hasApiPagination, showMoreInTable }) {
    const handleLocalShowMore = () => {
      if (showMoreInTable) {
        this.showMoreDataInTable()
      } else {
        this.openModalForViewAll()
      }
    }

    if (hasApiPagination && !hasHiddenLocalRows) {
      await Promise.resolve(this.props.onNext())
      this.showMoreDataInTable()
      return
    }

    handleLocalShowMore()
  }

  onCloseModal() {
    this.setState({
      modalOpen: false
    });
  }

  fullWidthCondition(fullWidthDialog) {
    if (fullWidthDialog) {
      return true
    }
    if (window.innerWidth && window.innerWidth < 480) {
      return true
    }
    return false
  }

  getStickyLeftOffset(index) {
    if (!this.tableRef) return 0

    const firstRow = this.tableRef.querySelector('thead tr')
    if (!firstRow) return 0

    const cells = firstRow.children
    let left = 0

    for (let i = 0; i < index; i++) {
      if (cells[i]) {
        left += cells[i].offsetWidth
      }
    }

    return left
  }

  getCellStyles(type, index, options = {}) {
    const baseStyles = []

    if (type === 'body') {
      const { textColumnIndices, noWrapColumnIndices, isModalTable, isDimensionFilterEnabled, isAdditionalInfoFound, cellWidth } = options
      if(this.props && this.props.hideRowSeparators) {
        baseStyles.push(Styles.cellBody, Styles.cellBodyNoBorder, cellWidth)
      } else {
        baseStyles.push(Styles.cellBody, cellWidth)
      }

      if (textColumnIndices && textColumnIndices.includes(index)) {
        if (isModalTable) {
          baseStyles.push(Styles.modalFirstColumn)
        } else {
          baseStyles.push(Styles.firstColumn)
        }

        if (isDimensionFilterEnabled) {
          baseStyles.push(Styles.dimensionFilter)
        }

        if (isAdditionalInfoFound) {
          baseStyles.push(Styles.additionInfoColumnContainer)
        }

        if(noWrapColumnIndices && noWrapColumnIndices.includes(index)) {
          baseStyles.push(Styles.noWrapColumn)
        }
      } else if (isAdditionalInfoFound) {
        baseStyles.push(Styles.additionInfoColumnContainer)
      }
    } else if (type === 'head') {
      const { textColumnIndices, isAdditionalInfoFound, cellWidths, header } = options

      baseStyles.push(Styles.cellHead, cellWidths[header])

      if (textColumnIndices && textColumnIndices.includes(index)) {
        baseStyles.push(Styles.firstColumn)
      } else if (isAdditionalInfoFound) {
        baseStyles.push(Styles.additionalInfoColumnHeader)
      }
    }

    if (options.stickyColumnIndices && options.stickyColumnIndices.includes(index)) {
      const left = this.getStickyLeftOffset(index)
      const dynamicStyle = StyleSheet.create({
        stickyLeft: {
          left
        }
      })
      baseStyles.push(Styles.stickyColumn,dynamicStyle.stickyLeft)
    }

    return baseStyles
  }


  renderModal() {
    const fullWidthDialog = (this.props.fullWidthDialog && window.innerWidth > 480)
    return(<Dialog
      open={this.state.modalOpen}
      fullWidth={true}
      fullScreen={this.fullWidthCondition(fullWidthDialog)}
      classes={{
        root: css(Styles.customRoot),
        paper: css(Styles.customPaper, AppHelper.isDialogScrollbarEnabled() && AppStyles.dialogScrollbar),
      }}
      BackdropProps={fullWidthDialog && { style: { backgroundColor: 'unset' } }}
      maxWidth='md'
    >
      <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
        <div className={css(Styles.modalTitle)}>{this.props.item.title}</div>
        <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
          <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
            <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
          </svg>
        </button>
      </div>
      <div className={css(Styles.modalContent)}>
        <TableCard item={{...this.props.item, title: ''}} isModalTable={true} disableTooltip={this.props.disableTooltip || false} tableRowActions={this.props.tableRowActions} cellWidths={this.props.cellWidths || {}}/>
      </div>
    </Dialog>)
  }

  render() {
    const {tableRowActions, showRowCollapse, collapseRowIndex, disableTooltip = false, cellWidths = {}, isModalTable = false, showMoreInTable = false, reverseRows = false, nextPage, onNext, nextPageState, tableActions} = this.props
    const {headers, headerTooltips, rows, textColumnIndices, noWrapColumnIndices, columnsWithAdditionalInfo, hiddenColumnIndices, hiddenColumnHeaders, renderCustomTableBody, renderTableRowCollapse, stickyColumnIndices} = this.props.item.data

    const processedRows = rows ? [...rows] : []

    if (reverseRows) {
      processedRows.reverse()
    }

    let displayedRows = []

    if(processedRows && processedRows.length > 0) {
      if(isModalTable) {
        displayedRows = processedRows
      } else {
        if(reverseRows) {
          displayedRows = processedRows.slice(Math.max(processedRows.length - this.state.maxRows, 0), processedRows.length)
        } else {
          displayedRows = processedRows.slice(0,this.state.maxRows)
        }
      }
    }

    const hasApiPagination = !isModalTable && !!(nextPage && onNext)
    const hasHiddenLocalRows = !isModalTable && !reverseRows && rows && rows.length > this.state.maxRows
    const shouldShowMoreButton = hasApiPagination || hasHiddenLocalRows

    const showMoreInProcess = this.state.localShowMoreInProcess || (nextPageState === ApiHelper.State.LOADING)
    const isTabTable = !!this.props.isTabTable
    const inProcess = this.props.inProcess || this.state.inProcess
    const lockTabMinHeight = !!this.props.lockTabMinHeight
    const tabTableRootClass = isModalTable
      ? [Styles.outerContainer, Styles.modalTableOuterContainer, AppHelper.isDialogScrollbarEnabled() && Styles.modalTableOuterContainerFill]
      : isTabTable
        ? [Styles.outerContainer, Styles.tabTableOuterContainer, lockTabMinHeight && Styles.tabTableLockFill]
        : Styles.outerContainer

    return (
      <div className={css(tabTableRootClass, this.props.containerStyle)}>
        {(this.props.item.title || this.state.showLeftScroll || this.state.showRightScroll || tableActions) && <div className={css(Styles.tableCardContainer)}>
          <div className={css(Styles.paperTitle, tableActions && Styles.paperTitleGrow)} elevation={0}>
            <p className={css(Styles.paragraphMargin)}>{this.props.item.title}</p>
          </div>
          {!inProcess && (headers && headers.length > 0 && rows && rows.length > 0) && (this.state.showLeftScroll || this.state.showRightScroll) && <div className={css(Styles.arrowContainer)}>
            <IconButton onClick={this.scrollLeft}
              disabled={!this.state.showLeftScroll}
              disableRipple
              disableFocusRipple>
              <ArrowBackIosIcon fontSize='small' />
            </IconButton>
            <IconButton onClick={this.scrollRight}
              disabled={!this.state.showRightScroll}
              disableRipple
              disableFocusRipple>
              <ArrowForwardIosIcon fontSize='small' />
            </IconButton>
          </div>}
          {tableActions && <div className={css(Styles.arrowContainer)}>
            {tableActions.map((action, index) => (
              <AppButton
                key={index}
                onClick={action.onClick}
                buttonText={action.label}
                icon={action.icon}
                buttonStyle={[Styles.button, Styles.tableActionButton]}
                buttonTextStyle={Styles.buttonText}
                iconContainerStyle={Styles.tableActionIconContainer}
              />
            ))}
          </div>}
        </div>}
        {inProcess && (isTabTable
          ? <div className={css(Styles.tabTableLoader, lockTabMinHeight && Styles.tabTableLoaderFill)}>
            <CircularProgress size={48} className={css(Styles.tabTableLoaderProgress)} />
          </div>
          : <div>
            <div className={css(Styles.loader)}>
              <CircularProgress size={48} className={css(Styles.progress)} />
            </div>
          </div>)}
        {!inProcess && <TableContainer
          className={css(isModalTable ? Styles.modalTableContainer : [Styles.tableContainer, lockTabMinHeight && Styles.tabTableBodyFill])}
          ref={ref => this.tableRef = ref}
          onScroll={this.handleScroll}>
          {(headers && headers.length > 0 && rows && rows.length > 0)  ? (<Table stickyHeader>
            {!(this.props && this.props.hideTableHeader) && <TableHead>
              <TableRow>
                {headers.map((header, index) => {
                  const isAdditionalInfoFound = columnsWithAdditionalInfo && columnsWithAdditionalInfo.includes(index)
                  if(!hiddenColumnIndices || !hiddenColumnIndices.includes(index)) {
                    return(<TableCell key={index} className={css(this.getCellStyles('head', index, { textColumnIndices, noWrapColumnIndices, isAdditionalInfoFound, cellWidths, header, stickyColumnIndices}))}>
                      <Tooltip
                        title={<span className={css(Styles.tooltip)}>{(headerTooltips && headerTooltips[index]) ? headerTooltips[index] : header}</span>}
                        placement='bottom'
                        className={css(Styles.tooltip)}
                        PopperProps={isModalTable ? {
                          disablePortal: true,
                        } : {}}
                        disableHoverListener={disableTooltip}
                        disableFocusListener={disableTooltip}
                        disableTouchListener={disableTooltip}
                      >
                        <span className={css(Styles.tooltipSourceContainer)}>{Array.isArray(hiddenColumnHeaders) && hiddenColumnHeaders.includes(header) ? '' : header }</span>
                      </Tooltip>
                    </TableCell>)
                  }
                }).filter(a => !!a)}
                {tableRowActions && <TableCell className={css(Styles.cellHead)}></TableCell>}
              </TableRow>
            </TableHead>}
            <TableBody>
              {displayedRows.map((row, rowIndex) => (
                <>
                <TableRow key={rowIndex}>
                  {row.map((cell, cellIndex) => {
                    const header = headers[cellIndex]
                    const cellWidth = header && cellWidths[header]
                    let customTableBodyCell = null
                    if(renderCustomTableBody) {
                      customTableBodyCell = renderCustomTableBody(cell,cellIndex)
                    }
                    if(customTableBodyCell) {
                      return customTableBodyCell
                    } else if(!hiddenColumnIndices || !hiddenColumnIndices.includes(cellIndex)) {
                      const isDimensionFilterEnabled = this.props.item.onTableDimensionFilterSelected && (textColumnIndices && textColumnIndices.includes(cellIndex))
                      const isAdditionalInfoFound = columnsWithAdditionalInfo && columnsWithAdditionalInfo.includes(cellIndex)
                      if(isAdditionalInfoFound) {
                        return(
                          <TableCell key={cellIndex} className={css(this.getCellStyles('body', cellIndex, {textColumnIndices,noWrapColumnIndices,isModalTable,isDimensionFilterEnabled,isAdditionalInfoFound,cellWidth,stickyColumnIndices}))}
                            onClick={ isDimensionFilterEnabled && (()=>this.props.item.onTableDimensionFilterSelected(cell))}
                          >
                            <div className={css(Styles.additionInfoColumn)}>
                              <span>{(cell.value || Number(cell.value) === 0) ? cell.value : ''}</span>
                              <Tooltip
                                title={<span className={css(Styles.tooltip)}>{cell.additionalInfo}</span>}
                                placement='top-right'
                                className={css(Styles.tooltip)}
                                PopperProps={isModalTable ? {
                                  disablePortal: true,
                                } : {}}
                                disableHoverListener={disableTooltip}
                                disableFocusListener={disableTooltip}
                                disableTouchListener={disableTooltip}
                              >
                                <span className={css(Styles.additionInfo)}>{cell.additionalInfo || ''}</span>
                              </Tooltip>
                            </div>
                          </TableCell>
                        )
                      }
                      return(
                        <TableCell key={cellIndex} className={css(this.getCellStyles('body', cellIndex, {textColumnIndices,noWrapColumnIndices,isModalTable,isDimensionFilterEnabled,isAdditionalInfoFound,cellWidth,stickyColumnIndices}))}
                          onClick={ isDimensionFilterEnabled && (()=>this.props.item.onTableDimensionFilterSelected(cell))}
                        >
                          <Tooltip
                            title={<span className={css(Styles.tooltip)}>{cell}</span>}
                            placement='top-start'
                            PopperProps={isModalTable ? {
                              disablePortal: true,
                            } : {}}
                            disableHoverListener={disableTooltip}
                            disableFocusListener={disableTooltip}
                            disableTouchListener={disableTooltip}
                          >
                            <span className={css(Styles.tooltipSourceContainer)}>{cell}</span>
                          </Tooltip>
                        </TableCell>
                      )
                    }
                  }).filter(a => !!a)}
                  {tableRowActions && <TableCell className={css((this.props && this.props.hideRowSeparators) ? [Styles.cellBody, Styles.cellBodyNoBorder] : Styles.cellBody)}>
                    {tableRowActions(headers,row, rowIndex)}
                  </TableCell>}
                </TableRow>
                {showRowCollapse && collapseRowIndex === rowIndex &&  renderTableRowCollapse && renderTableRowCollapse(rowIndex)}
                </>
              ))}
            </TableBody>
          </Table>) : (<div className={css(this.props.compactEmpty ? Styles.emptyViewContainerCompact : Styles.emptyViewContainer)}><p className={css(Styles.emptyViewText)}>{Helper.getString('noDataAvailable')}</p></div>)}
          {shouldShowMoreButton && <div className={css(Styles.tableFooterContainer)}>
            <AppButton
              onClick={() => this.onShowMoreClick({ hasHiddenLocalRows, hasApiPagination, showMoreInTable })}
              buttonText={'SHOW MORE'}
              buttonStyle={Styles.button}
              buttonTextStyle={Styles.buttonText}
              progressIcon={Styles.buttonProgress}
              inProcess={showMoreInProcess}
              disabled={showMoreInProcess}
            />
          </div>}
        </TableContainer>}
        {this.state.modalOpen ? this.renderModal() : ''}
      </div>
    );
  }
}

export default TableCard;

const Styles = StyleSheet.create({
  tableCardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  arrowContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 5
  },
  outerContainer: {
    border: '1px solid ' + AppTheme.borderColor,
    padding: '10px 30px 20px 30px',
    borderRadius: AppTheme.borderRadius,
    flex: 1,
    '@media (max-width: 1024px)': {
      padding: '10px 10px',
      borderRadius: 8,
    },
  },
  tabTableOuterContainer: {
    border: 0,
  },
  tabTableLockFill: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  tabTableBodyFill: {
    flex: 1,
    minHeight: 0,
  },
  tabTableLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 400,
    '@media (max-width: 767px)': {
      minHeight: 200,
    },
  },
  tabTableLoaderFill: {
    flex: 1,
    minHeight: 0,
    '@media (max-width: 767px)': {
      minHeight: 0,
    },
  },
  tabTableLoaderProgress: {
    color: AppTheme.primaryColor,
  },
  modalTableOuterContainer: {
    border: 0,
    width: '100%',
    height: '100%',
  },
  modalTableOuterContainerFill: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  tableContainer: {
    position: 'relative',
  },
  modalTableContainer: {
    position: 'relative',
    maxHeight: 580,
    overflowY: 'auto',
  },
  paperFooter: {
    marginBottom: 0,
    display: 'flex',
    verticalAlign: 'top',
    justifyContent: 'flex-end'
  },
  paperTitle: {
    height: '40px',
    fontWeight: 'bold',
    color: AppTheme.white,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 1024px)': {
      height: '20px',
    },
  },
  subText: {
    display: 'inline-block',
    fontSize: 24,
    fontWeight: 'bold',
    flex: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'default',
    '@media(max-width: 768px)': {
      fontSize: 12
    }
  },
  arrowUp: {
    color: 'green'
  },
  arrowDown: {
    color: 'red'
  },
  videoContainerTile: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paragraphMargin: {
    margin: 0,
    flex: 1,
    fontSize: 20,
    fontWeight: 500,
    '@media(max-width: 1024px)': {
      fontSize: 20
    }
  },
  progress: {
    color: AppTheme.white
  },
  loader: {
    minHeight: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cellHead: {
    backgroundColor: 'white',
    color: '#9B9B9B',
    height: 38,
    fontSize: 16,
    fontWeight: 'bold',
    padding: '8px 8px 8px 8px',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      fontSize: 10,
      padding: '8px 2px 8px 2px',
    },
  },
  cellBody: {
    backgroundColor: 'white',
    color: CommonTheme.textColor,
    // minHeight: 72,
    borderBottom: '1px solid ' + AppTheme.borderColor,
    fontSize: 16,
    textAlign: 'center',
    padding: '16px 5px',
    verticalAlign: 'middle',
    wordBreak: 'break-all',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,

    '@media (max-width: 767px)': {
      fontSize: 10,
      padding: '16px 2px',
    },
  },
  cellBodyNoBorder:{
    borderBottom: 'none',
  },
  tableFooterContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 15,
  },
  firstColumn: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    // overflowX: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
    '@media(max-width: 767px)': {
      maxWidth: 'unset',
      whiteSpace: 'unset',
    }
  },
  noWrapColumn: {
    whiteSpace: 'unset',
    '@media(max-width: 767px)': {
      whiteSpace: 'unset',
    }
  },
  modalFirstColumn: {
    textAlign: 'left',
    '@media(max-width: 767px)': {
      maxWidth: 'unset',
      whiteSpace: 'unset',
    }
  },
  dimensionFilter: {
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
      textDecorationColor: '#9B9B9B',
      textUnderlineOffset: 2,
    }
  },
  additionalInfoColumnHeader: {
    textAlign: 'right'
  },
  additionInfoColumnContainer: {
    maxWidth: 300,
  },
  additionInfoColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  additionInfo: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 300,
    fontSize: 14,
    color: '#0000008A',
    '@media (max-width: 1024px)': {
      fontSize: 10,
    }
  },
  emptyViewContainer: {
    width: '100%',
    height: '100%',
    minHeight: 400,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  emptyViewContainerCompact: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px 0',
  },
  emptyViewText: {
    fontSize: 20,
    color: 'grey',
    '@media (max-width: 1024px)': {
      fontSize: 16,
    }
  },
  button: {
    color: AppTheme.primaryColor,
    border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 500
  },
  buttonProgress: {
    color: AppTheme.primaryColor
  },
  paperTitleGrow: {
    flex: 1,
  },
  tableActionButton: {
    height: 40,
    minWidth: 'unset',
    padding: '0 15px',
  },
  tableActionIconContainer: {
    border: 0,
    padding: 0,
    marginRight: 6,
    color: AppTheme.primaryColor,
  },
  modalHeader: {
    // backgroundColor: 'whitesmoke',
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: 20,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
    }
  },
  modalTitle: {
    color: CommonTheme.textColor,
    fontSize: 26,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // marginRight: 28,
    flex: 1,
    '@media (max-width: 767px)': {
      fontSize: 20,
      marginRight: 43,
    }
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 30,
    paddingRight: 30,
    minHeight: 400,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
      minHeight: 200,
    }
  },
  modalCloseButton: {
    // position: 'absolute',
    // top: 23,
    // right: 30,
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    border: 'none'
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    border: '1.5px solid' + AppTheme.primaryColor,
    fill: AppTheme.primaryColor,
    borderRadius: 8
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 767px)': {
      borderRadius: 0,
    },
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  customRoot: {
    zIndex: 13000
  },
  customPaper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      borderRadius: 0,
      width: '95%',
      height: 'max-content',
      maxHeight: '95%'
    },
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tooltip: {
    fontSize: 12
  },
  tooltipSourceContainer: {
    fontSize: 16,
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
  stickyColumn: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: 'white',
  },
});
